import { combineReducers } from "redux";

import listInfinitiveScrollReducer from "components/common/ListInfinitiveScrolling/redux";
import layoutsReducer from "layouts/Sidenav/redux";
import authReducer from "modules/Auth/redux";
// import declareLeaveReducer from "modules/DeclareLeave/redux";
import homepageReducer from "modules/Homepage/redux";
import newsReducer from "modules/News/redux";
// import personnelFormReducer from "modules/PersonnelForm/redux";
import personnelInformationReducer from "modules/PersonnelInformation/redux";
// import regulationsReducer from "modules/Regulations/redux";
import researchReportReducer from "modules/ResearchReport/redux";
// import workPerformanceReducer from "modules/WorkPerformance/redux";
import themesReducer from "theme/redux";
import staticReducer from "./static/redux";

// import internalCultureReducer from "modules/InternalCulture/redux";
import { AppReducerType } from "./types";
import operationProcessReducer from "modules/OperationProcess/redux";
import internalDocumentReducer from "modules/InternalDocuments/redux";
import authorizationDocumentReducer from "modules/AuthorizationDocument/redux";
import declareLeaveReducer from "modules/DeclareLeave/redux";
import eventsReducer from "modules/Event/redux";
import birthdayReducer from "modules/Birthday/redux";
import updateDeviceStatusReducer from "modules/Notification/redux";
import recruitmentReducer from "modules/Recruitment/redux";
import evaluationReducer from "modules/Evaluation/redux";
import salaryReducer from "modules/Salary/redux";

export default combineReducers({
  [AppReducerType.STATIC]: staticReducer,
  [AppReducerType.THEMES]: themesReducer,
  [AppReducerType.LAYOUTS]: layoutsReducer,
  [AppReducerType.AUTHENTICATION]: authReducer,
  [AppReducerType.HOMEPAGE]: homepageReducer,
  [AppReducerType.PERSONNEL_INFORMATION]: personnelInformationReducer,
  // [AppReducerType.WORK_PERFORMANCE]: workPerformanceReducer,
  [AppReducerType.DECLARE_LEAVE]: declareLeaveReducer,
  // [AppReducerType.PERSONNEL_FORM]: personnelFormReducer,
  // [AppReducerType.REGULATIONs]: regulationsReducer,
  // [AppReducerType.INTERNAL_CULTURE]: internalCultureReducer,
  [AppReducerType.NEWS]: newsReducer,
  [AppReducerType.RESEARCH_REPORT]: researchReportReducer,
  [AppReducerType.INFINITIVE_SCROLL]: listInfinitiveScrollReducer,
  [AppReducerType.OPERATION_PROCESS]: operationProcessReducer,
  [AppReducerType.INTERNAL_DOCUMENT]: internalDocumentReducer,
  [AppReducerType.AUTHORIZATION_DOCUMENT]: authorizationDocumentReducer,
  [AppReducerType.EVENTS]: eventsReducer,
  [AppReducerType.NOTIFICATION]: updateDeviceStatusReducer,
  [AppReducerType.RECRUITMENT]: recruitmentReducer,
  [AppReducerType.EVALUATION]: evaluationReducer,
  [AppReducerType.SALARY]: salaryReducer,
  [AppReducerType.BIRTHDAY]: birthdayReducer,
});
